import React from 'react';
import _ from 'lodash';

export default function Bulk() {
  return (
    <div>Bulk</div>
  )
}